import * as angular from 'angular';


import {performance} from './performance';

export const performanceModule = 'performance';

angular
  .module(performanceModule, [])
  .component('performance', performance)



// WEBPACK FOOTER //
// ./src/app/performance/performance.index.ts